import React from "react";

import find from "lodash/find";
import classnames from "classnames";
import { constToCSS } from "../../reducers/download";
import { ALACARTE_TYPE, PREPAID_TYPE, PRO_TYPE } from "../../reducers/stripe";
import * as actions from "../../actions/actions";
import { connect } from "react-redux";
import ToolTip from "../tool-tip";
import NounProAppsList from "../noun-pro-apps-list";

import "intl";
import "intl/locale-data/jsonp/en.js";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

const onNumIconsChange = props => evt => {
    let { value } = evt.target;
    props.stripePrepaidNumIconsChange(value);
    evt.stopPropagation();
};

const preventPropagation = props => evt => {
    if (props.currentPurchase && props.currentPurchase.type == PREPAID_TYPE) {
        evt.stopPropagation();
    }
};

const PurchaseType = props => {
    let { purchaseType, currentPurchase, singleIconPriceCents } = props;
    if (purchaseType.hide) {
        return;
    }
    let current = currentPurchase && purchaseType.key == currentPurchase.key;

    let wrapperClass = classnames(
        "purchase-type",
        `purchase-type-${constToCSS(purchaseType.key)}`
    );
    let optionClass = classnames(
        {
            current
        },
        "bubble-choice",
        `purchase-${constToCSS(purchaseType.key)}`
    );
    let { period, price } = purchaseType;

    let text =
        purchaseType.text || `${purchaseType.type}, ${purchaseType.period}`;

    let subText;

    let priceDispay = price ? formatter.format(price / 100) : "";
    let periodDisplay;

    let description;
    switch (purchaseType.type) {
        case PRO_TYPE: {
            periodDisplay = (
                <div className="pro-info">/{period.replace("ly", "")}</div>
            );

            subText = (
                <div className="pro-info">
                    Unlimited Icons{" "}
                    {period === "yearly" ? (
                        <span className="pro-blue">best value</span>
                    ) : null}
                </div>
            );

            description = (
                <div className="text">
                    {period === "yearly" ? "Yearly" : "Monthly"} subscriptions
                    unlock all apps and plugins and include free icon editing.
                </div>
            );
            break;
        }
    }
    let component = (
        <div className={wrapperClass} onClick={props.onClick}>
            <div className="marker" />
            <li className={optionClass}>
                <span className="plan-text">
                    {text}
                    {subText}
                </span>
                <span className="plan-price">
                    <span data-test="price-display">{priceDispay}</span>
                    {periodDisplay}
                </span>
            </li>
            {description}
        </div>
    );

    return component;
};

const NounProInfo = props => {
    return (
        <div className="noun-pro-info-section">
            <p>
                <a
                    href="/accounts/upgrade"
                    target="_blank"
                    className="pro-blue"
                >
                    NounPro Subscriptions
                </a>
                <br />
                include apps for
            </p>
            <NounProAppsList />
            {props.children}
        </div>
    );
};

function mapStateToProps(state, ownProps) {
    let { stripe } = state;
    let { prepaidNumIcons, purchaseTypes } = stripe;
    let alacartePurchase = find(purchaseTypes, { key: ALACARTE_TYPE });
    let singleIconPriceCents = alacartePurchase.price;
    return {
        prepaidNumIcons,
        singleIconPriceCents
    };
}

export default connect(mapStateToProps, {
    stripePrepaidNumIconsChange: actions.stripePrepaidNumIconsChange,
    stripePrepaidNumIconsBlur: actions.stripePrepaidNumIconsBlur
})(PurchaseType);
